import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Group from '../courses/group';
import Typography from '@material-ui/core/Typography'
import { LoadingIndicator } from '../../components';
import Tile from '../../components/tile/exam-tile';
import theme from '../../app.theme';
import SearchBar from '../search/search-bar/index';
import env from '../../../run-config';
import { ThemeColors } from '../../theme';
import moment from 'moment'
import StartExamDialog from './start-exam-dialog';

const findTypeById = (list, id, type) => {
    if (!list) {
        return null;
    }

    let match = null;
    list.forEach((cg) => {
        if (cg.type == type && cg.id == id) {
            match = cg;
            return;
        }

        if (!match && cg.type === 'group') {
            match = findTypeById(cg.children, id, type);
        }
    });
    return match;
};

class Exams extends Component {
    constructor(props) {
        super(props);

        this.examBaseUrl = this.props.match.url;
        this.state = {
            selectedExam: null,
            startExamDialogOpen: false,
        };
    }

    componentWillMount() {
        this.props.loadExams();
        // this.props.onLoadTests();
        // this.props.onLoadCourses();
    }

    handleExamStarted = (test) => {
        this.props.history.push(`${this.examBaseUrl}/${test.id}`);
        this.props.startNewTestRun(test, this.state.selectedExam.id);
      };

    checkStartDateReached(examDate) {
        const startDate = moment(examDate.startDate);
        const today = moment(new Date());
        return today.diff(startDate) > 0;
    }

    checkEndDateReached(examDate) {
        const endDate = moment(examDate.endDate);
        const today = moment(new Date());
        return today.diff(endDate) > 0;
    }

    handleStartExam = (exam) => {
        const testRuns = this.props.testRuns;
        // const openRunForTest = testRuns.find(t => t.testId === exam.test.id);
        const openRunForTest = testRuns.find(t => t.examId == exam.id);
        if (openRunForTest) {
          this.props.loadTest(exam.test);
          this.props.setTestRun(openRunForTest);
          this.props.history.push(`${this.examBaseUrl}/${exam.test.id}`);

        } else {
            this.setState({ startExamDialogOpen: true, selectedExam: exam })
        }  
    }

    getActiveExams(data) {
        if (!data) return null;
        return data.filter(d => d.isActive)
    }

    getUpcommingExams(data) {
        if (!data) return null;
        return data.filter(d => !d.isActive);
    }

    renderTestGroups(data) {
        return (data.map(group => <Group
            key={group.id}
            group={group}
            onClickShare={this.onClickShare}
        />));
    }

    renderTiles(title, exams, isUpcoming) {
        var tiles = exams.map((exam, i) => <Tile
            className={'tile'}
            key={i}
            exam={exam}
            isUpcoming={isUpcoming}
            title={exam.test.name}
            courseGroups={this.props.courseGroups}
            testGroups={this.props.testGroups}
            description={exam.test.description}
            onClick={() => this.handleStartExam(exam)}
            imageUrl={exam.test.imageUrl}
            progress={exam.test.progress}
        />)

        const emptyMessage = !exams || exams.length < 1
            ? <Typography>Keine Prüfungen gefunden</Typography>
            : null;

        return (
            <div>
                <h1 style={{ color: ThemeColors.accent2Color }}>{title}</h1>
                {tiles}
                {emptyMessage}
            </div>
        )

    }

    onSearch(searchTerm) {
        this.props.navigate(`search?searchTerm=${searchTerm}`);
    }

    onClickShare(test) {
        const url = `${env.apiHost}/tests/${test.id}/all`;
        this.props.onExportContent(url);
    }

    render() {
        if (this.props.isLoading) {
            return <LoadingIndicator show centered />;
        }

        if (!this.props.exams) return null;

        var activeExams = this.getActiveExams(this.props.exams)
        var upcomingExams = this.getUpcommingExams(this.props.exams)

        return (
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div style={{ display: 'flex', flexDirection: 'column'}}>
                    {this.renderTiles('Verfügbare Prüfungen', activeExams)}
                    {this.renderTiles('Gesperrte Prüfungen', upcomingExams, true)}
                </div>
                <StartExamDialog 
                    open={this.state.startExamDialogOpen}
                    onClose={() => this.setState({ startExamDialogOpen: false})}
                    exam={this.state.selectedExam}
                    handleExamStarted={this.handleExamStarted}
                    />
            </div>
        );
    }
}

export default Exams;



// WEBPACK FOOTER //
// ./src/app/main/exams/exams.js